<script lang="ts">
    import BaseTab from "@/tabs/mixins/BaseTab";
    import tabIcon from "@/assets/gear.svg";
    export default {
        extends: BaseTab,
        name: "ListStudieKvalitetsregister",
        tabName: "Studie/Kvalitetsregister",
        icon: tabIcon,
    };
</script>
<script setup lang="ts">
    import { ref, computed, onBeforeMount } from "vue";
    import { useStore } from "@/store";
    import PlusCircleBlue from "@/assets/plus_circle_blue.svg";
    import KlinikenTable from "@/components/Table/KlinikenTable.vue";
    import AdminLockBorder from "@/components/AdminLockBorder.vue";
    import StudieKvalitetsregisterForm from "@/tabs/Operation/Admin/StudieKvalitetsregisterForm.vue";
    import HollowButton from "@/components/widgets/HollowButton.vue";

    const store = useStore();
    const listLimit = ref<number>(20);
    const offset = ref(0);

    const TABLE_COLUMNS = [
        { name: "namn", title: "Namn", template: (item: any) => item.namn || "" },
        { name: "ordning", title: "Ordningsnummer", template: (item: any) => item.ordning || "" },
    ];

    const TABLE_ACTIONS = [
        { name: "edit", title: "Redigera Studie/Kvalitetsregister", img: "edit.svg", show: () => true },
    ];

    const studieKvalitetsregister = computed(() =>
        [...store.getters["studieKvalitetsregister/studieKvalitetsregister"]].sort((a, b) => a.ordning - b.ordning)
    );
    const next = computed(() => store.getters["studieKvalitetsregister/next"]);

    const loadStudieKvalitetsregisterList = () =>
        store.dispatch("studieKvalitetsregister/fetchStudieKvalitetsregister", {
            limit: listLimit.value,
            page: offset.value,
            filterParams: {},
        });
    const loadNext = () => store.dispatch("studieKvalitetsregister/loadNext");
    const createKvalitetsregister = async () => {
        await store.dispatch("tabs/openTab", {
            component: StudieKvalitetsregisterForm,
            parameters: { limit: listLimit.value },
        });
    };

    const updateKvalitetsregister = async (register: any) => {
        await store.dispatch("tabs/closeTab", StudieKvalitetsregisterForm);
        await store.dispatch("tabs/openTab", {
            component: StudieKvalitetsregisterForm,
            parameters: { register, limit: listLimit.value },
        });
    };
    onBeforeMount(() => {
        loadStudieKvalitetsregisterList();
    });
</script>

<template>
    <div class="pad">
        <admin-lock-border />
        <h2>
            Studie/Kvalitetsregister
            <hollow-button
                @click="createKvalitetsregister"
                :icon="PlusCircleBlue"
                label="Skapa ny studie/kvalitetsregister"
            />
        </h2>
        <kliniken-table
            :items="studieKvalitetsregister"
            :columns="TABLE_COLUMNS"
            :dropdown-actions="TABLE_ACTIONS"
            :selectable-rows="false"
            @edit="updateKvalitetsregister"
            :limit="listLimit"
            :showBottom="true"
            :showLimitDropdown="true"
            :has-dropdown="true"
        />
        <button class="load-next" v-if="next" @click="loadNext">Visa nästa X rader</button>
    </div>
</template>

<style lang="scss" scoped>
    .load-next {
        float: right;
    }

    .pad {
        height: 100%;
    }
</style>
